<template>
    <Vin 
     :formTitle="textObj.formTitle"
      :vin="vinValue"
      :model="modelValue"
      :vinLabel="textObj.vinLabel"
      :modelLabel="textObj.modelLabel"
      :isLoading="isLoading"
      :isSuccess="isSuccess"
      :isFail="isFail"
      :failMessage="failMessage"
      :resultData="resultData"
      :successColor="'rgba(22, 189, 51, 0.1)'"
    >
      <!-- 使用共享的成功内容组件 -->
      <template v-slot:success-content>
        <VinSuccessContent :resultData="resultData" />
      </template>
      <!-- 使用共享的失败内容组件 -->
      <template v-slot:fail-content>
        <VinFailContent 
          :failMessage="failMessage" 
        />
      </template>
    </Vin>
</template>

<script>
import sessionAPI from '@/api/session'
import { updateQueryResult, getUserRealtiveInfo, getSignFromUrl } from '../pc/message/message-elements/vin-ota/common-untils'
import Vin from '../pc/message/message-elements/vin.vue'
import VinSuccessContent from '../pc/message/message-elements/vin-ota/vin-success-content.vue'
import VinFailContent from '../pc/message/message-elements/vin-ota/vin-fail-content.vue'
import vinOtaData from '../pc/message/message-elements/vin-ota/vin-ota-data'
import { DEFAULT_FAIL_MESSAGE } from '../pc/message/message-elements/vin-ota/vin-ota-data'


// 测试链接：http://localhost:8080/H5/mobile/vinOta?appid=wx3556c7be5b517aed&enterid=56&appAuthCode=7c5fe2352903ce13248c7af2bd681fd5&nickName=%E9%A1%B9%E4%BD%A9%E8%8A%B3-%E4%B8%8D%E8%A6%81%E6%8E%A5%E8%B5%B0%E6%88%91%E7%9A%84%E4%BC%9A%E8%AF%9D&avatarUrl=https%3A%2F%2Fcache.bydauto.com.cn%2Fdilink_user_upload_dev%2Funion_avatar%2Ffcb%2F202604%2F17%2F185641nmhbggMV.png&isAuth=0&timeStamp=1776936862000&vin=LAHUGYBJ7K6395282&user_id=1111137756&modelVaule=FG09
export default {
  components: { Vin, VinSuccessContent, VinFailContent },
  data() {
    return {
      // 从共享配置导入
      textObj: vinOtaData.textObj,
      // 状态管理
      isLoading: true,
      isSuccess: false,
      isFail: false,
      vinValue: '',
      modelValue: '',
      resultData: null,
      failMessage: ''
    }
  },
  async mounted() {
    try {
      // 获取URL上的sign参数
      this.sign = getSignFromUrl()
      
      // 调用getUserRealtiveInfo获取用户相关信息
      await getUserRealtiveInfo({ instance: this })
      console.log('请求两个桥后的this.vinValue==>',this.vinValue,'请求两个桥后的this.userID==>',this.userID)
      // 这个接口对于app和h5，都必须要用userID参数
      if (this.userID) {
        // 调用查询接口
        this.queryVINOTAInfo()
      } else {
        // 参数不完整，显示错误信息
        this.isLoading = false
        this.isFail = true
        this.failMessage =DEFAULT_FAIL_MESSAGE
        console.log('参数不完整==>')
      }
    } catch (error) {
      console.log('请求两个桥后的被reject了==>',error)
      // 两个桥中有一个失败，执行失败逻辑
      this.isLoading = false
      this.isFail = true
      this.failMessage =DEFAULT_FAIL_MESSAGE
    }
  },
  methods: {
    // 查询VIN OTA信息
      async queryVINOTAInfo() {
      try {
        this.isLoading = true
        this.isSuccess = false
        this.isFail = false
        this.failMessage = ''
        
        // 调用接口
        const response = await sessionAPI.queryOTAUpdate({
         vin:this.vinValue,
         userId:this.userID,
         sign:this.sign,
         carSeries:this.modelValue
        })
        console.log('queryOTAUpdate 请求返回:', response)
        
        // 处理成功响应
        // 使用公共工具函数更新查询结果
        updateQueryResult({instance:this, defaultFailMsg:'未查询到车辆OTA升级信息',response,isApp:true})
      } catch (error) {
        console.log('queryOTAUpdate 请求失败报错==>',error)
        // 处理失败响应
        this.isLoading = false
        this.isFail = true
        
        // 根据错误类型设置失败消息
        if (error.code === 'ECONNABORTED') {
          this.failMessage = DEFAULT_FAIL_MESSAGE
          console.error('查询超时，请稍后重试')
        } else {
          this.failMessage =DEFAULT_FAIL_MESSAGE
          console.error('查询VIN OTA信息失败:', error)
        }
        
        console.error('查询VIN OTA信息失败:', error)
      }
    },
    
    /**
     * 处理FAQ点击事件
     * @param {string} item - 点击的FAQ内容
     */
    // handleQuestionClick(item) {
    //   console.log('移动端点击FAQ:', item)
    //   // 这里可以根据需要添加处理逻辑
    //   // 例如：发送消息到服务器或调用其他方法
    // }
  }
}
</script>
